import { getCardAndFieldLabel } from 'utils/validationParserUtils';
import { ResolvedErrorField } from '../resolveErrorField';
import getFallbackFieldLabel from './getFallbackFieldLabel';
import { ErrorCardContext } from './types';

/**
 * The label of an error's field: the card and field the parser names it by, or - for a field no card
 * shows, such as Box 44 - a fallback built from the path inside the item or the declaration.
 */
const labelErrorField = (
    path: string,
    field: ResolvedErrorField,
    firstNumber: 0 | 1,
    { parser, box44Paths }: ErrorCardContext
): string => {
    const parserLabel = parser && getCardAndFieldLabel(parser, path, firstNumber);
    if (parserLabel) return parserLabel;

    const box44Path = field.item ? box44Paths?.productPath : box44Paths?.masterPath;
    return getFallbackFieldLabel(field.formPath, box44Path);
};

export default labelErrorField;
